import { useQuery } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import { getCryptocurrenciesV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useCryptocurrenciesQuery = () => {
	return useQuery({
		queryKey: PortfolioKeys.cryptocurrencies(),
		queryFn: processResponse(() => getCryptocurrenciesV2()),
	});
};
